const STORAGE_KEY = 'agorax_asistencia_pendientes';

function getHoraCliente() {
  const n = new Date();
  const p = (v) => String(v).padStart(2, '0');
  return `${n.getFullYear()}-${p(n.getMonth() + 1)}-${p(n.getDate())}T${p(n.getHours())}:${p(n.getMinutes())}:${p(n.getSeconds())}`;
}

export function queueAttendance(tipo, tokenQR) {
  const entry = {
    id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8),
    tipo,
    token_qr: tokenQR,
    hora_cliente: getHoraCliente(),
    timestamp: new Date().toISOString(),
    retries: 0,
  };
  const pendientes = getQueue();
  pendientes.push(entry);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pendientes));
  return entry;
}

export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch (e) {
    return [];
  }
}

export function getQueueCount() {
  return getQueue().length;
}

function removeFromQueue(id) {
  const pendientes = getQueue().filter((e) => e.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pendientes));
}

function updateRetry(id) {
  const pendientes = getQueue().map((e) => (e.id === id ? { ...e, retries: e.retries + 1 } : e));
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pendientes));
}

async function trySend(API, body) {
  try {
    const res = await API.post('/asistencia/registrar', body);
    return res;
  } catch (e) {
    if (e.response?.status === 422) {
      return await API.post('/asistencia/registrar', null, { params: body });
    }
    throw e;
  }
}

export async function flushQueue(API) {
  const pendientes = getQueue();
  if (pendientes.length === 0) return;

  console.log('[attendanceQueue] Flushing', pendientes.length, 'pendientes');
  for (const e of pendientes) {
    if (e.retries >= 120) {
      console.warn('[attendanceQueue] Maximos reintentos, descartando:', e.id);
      removeFromQueue(e.id);
      continue;
    }
    const body = { tipo: e.tipo, token_qr: e.token_qr, hora_cliente: e.hora_cliente };

    let ok = false;
    try {
      const res = await trySend(API, body);
      if (res.data.status === 'success') {
        console.log('[attendanceQueue] Registro enviado!', e.id);
        ok = true;
      } else {
        console.warn('[attendanceQueue] Backend rechazo:', e.id, res.data);
        ok = true;
      }
    } catch (err) {
      const status = err.response?.status;
      const detail = (err.response?.data?.detail || '').toLowerCase();
      const esPermanente =
        status === 409 ||
        (status === 400 &&
          (detail.includes('token qr invalido') ||
            detail.includes('qr no valido') ||
            detail.includes('qr revocado') ||
            detail.includes('qr expirado')));

      if (esPermanente) {
        console.warn('[attendanceQueue] Error permanente, descartando:', e.id, detail);
        ok = true;
      } else if (status) {
        console.warn('[attendanceQueue] Error HTTP', status, 'reintentando:', e.id, detail);
      } else {
        console.warn('[attendanceQueue] Network Error, reintentando:', e.id, err.message);
      }
    }
    if (ok) {
      removeFromQueue(e.id);
    } else {
      updateRetry(e.id);
    }
  }
}
